import store from '@/state/store'

const menuList = [
  {
    title: 'report.title.fleetManagement',
    desc: 'report.text.fleetManagement',
    shown: true,
    domain: 'fleet',
    badge: {
      text: 'global.new',
    },
  },
  {
    title: 'report.title.deliveryManagement',
    desc: 'report.text.deliveryManagement',
    shown: store.getters['identity/hasAccessAll']([
      'tms:create',
      'tms:read',
      'tms:update',
      'tms:delete',
    ]),
    domain: 'delivery'
  },
]

export default menuList
